import React from "react";

const BlogForm = ({ handleChange, handleSubmit, input }) => {
  return (
    <div className="flex  justify-center">
      <form onSubmit={handleSubmit} className="w-10/12 md:w-6/12 mt-10">
        <div>
          <input
            className="block w-full text-sm py-4 px-4 rounded-t-lg border-transparent  outline-none"
            type="text"
            name="title"
            placeholder={"Enter Blog Title"}
            value={input.title || ""}
            onChange={handleChange}
          />
        </div>

        <div>
          <textarea
            name="content"
            className=" block w-full text-sm rounded-b-lg bg-white border-transparent px-3 pt-2  outline-none"
            placeholder="Enter Blog Content"
            rows="10"
            value={input.content || ""}
            onChange={handleChange}
          ></textarea>
        </div>

        <div>
          <button className="bg-gray-800 md:w-1/4 w-1/3 rounded-2xl p-3 text-white text-sm md:text-base mt-3">
            Add Post
          </button>
        </div>
      </form>
    </div>
  );
};

export default BlogForm;
